function getRemovedFormFields(formValues: object, index: number): string[] {
  return Object.keys(formValues).filter(formField => {
    const formIndex = formField.split('_')[1];
    return formIndex === index.toString();
  });
}

export { getRemovedFormFields };
